import React from "react";
import { createBrowserRouter, Navigate } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import SignedInRoute from "./SignedInRoute";
import Login from "../routes/login";
import VerifyEmail from "../routes/verifyEmail";
import DefaultLayout from "../layout/defaultLayout/defaultLayout";
import Settings from "../routes/settings";
import Stats from "../routes/stats";
import Signup from "../routes/signup";
import ForgotPassword from "../routes/forgotPassword";
import ChangePassword from "../routes/changePassword";
import Chatbot from "../components/chatbot";
import Dashboard from "../routes/dashboard";

const router = createBrowserRouter([
  {
    path: "/login",
    element: (
      <SignedInRoute>
        <Login />
      </SignedInRoute>
    ),
  },
  {
    path: "/signup",
    element: (
      <SignedInRoute>
        <Signup />
      </SignedInRoute>
    ),
  },
  {
    path: "/verify-email/:token",
    element: (
      <SignedInRoute>
        <VerifyEmail />
      </SignedInRoute>
    ),
  },
  {
    path: "/verification-code",
    element: (
      <SignedInRoute>
        <VerifyEmail />
      </SignedInRoute>
    ),
  },
  {
    path: "/forgot-pasword",
    element: (
      <SignedInRoute>
        <ForgotPassword />
      </SignedInRoute>
    ),
  },
  {
    path: "/change-pasword/:token",
    element: (
      <SignedInRoute>
        <ChangePassword />
      </SignedInRoute>
    ),
  },

  {
    path: "/",
    element: (
      <ProtectedRoute>
        <Navigate to="/dashboard/overview" replace />
      </ProtectedRoute>
    ),
  },
  {
    path: "/dashboard/:tab",
    element: (
      <ProtectedRoute>
        <DefaultLayout>
          {/* Note: Components will handle :tab param (overview, knowledge) */}
          <Dashboard />
        </DefaultLayout>
      </ProtectedRoute>
    ),
  },
  {
    path: "/dashboard",
    element: (
      <ProtectedRoute>
        <DefaultLayout>
          <Dashboard />
        </DefaultLayout>
      </ProtectedRoute>
    ),
  },
  {
    path: "/global-knowledge",
    element: (
      <ProtectedRoute>
        <DefaultLayout>
          {/* Global Knowledge View */}
          {/* We need to import Knowledgesources here, but routes.js imports are static */}
          {/* Better approach: Let Dashboard handle 'knowledge' tab or add direct route */}
          {/* Going with direct import approach if possible, or wrapping in Stats? */}
          {/* Wait, Stats is for Projects. Dashboard is for Global. */}
          {/* Let's route /dashboard/knowledge to a wrapper that renders KnowledgeSources(isGlobal) */}
          <Dashboard />
        </DefaultLayout>
      </ProtectedRoute>
    ),
  },
  {
    path: "/project/:projectId/:route",
    element: (
      <ProtectedRoute>
        <DefaultLayout>
          <Stats />
        </DefaultLayout>
      </ProtectedRoute>
    ),
  },
  {
    path: "/project/:projectId",
    element: (
      <ProtectedRoute>
        <DefaultLayout>
          <Stats />
        </DefaultLayout>
      </ProtectedRoute>
    ),
  },
  {
    path: "/generalchat/:id",
    element: <Chatbot />,
  },
  {
    path: "/chat/:id",
    element: <Chatbot />,
  },
  {
    path: "/settings/:route",
    element: (
      <ProtectedRoute>
        <DefaultLayout>
          <Settings />
        </DefaultLayout>
      </ProtectedRoute>
    ),
  },
]);

export default router;
